import FixtureLineups from "./FixtureLineups";
export default FixtureLineups;
